import { RespetoPrincipiosAdapter } from '../adapters/RespetoPrincipios.adapter'

export default class GetEvaluacionRespetoPrincipiosUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute({ idPersonal, idEvaluacion }) {
    try {
      const dto = await this.#repository.getById(idPersonal, idEvaluacion)
      return RespetoPrincipiosAdapter.toEntity(dto)
    } catch (error) {
      throw new Error(`Failed to execute GetEvaluacionRespetoPrincipiosUseCase: ${error.message}`)
    }
  }
}
